'use client';
var assemble = function(fn, context, strategy, cache, serializer) {
    return strategy.bind(context, fn, cache, serializer);
};

export { assemble };
